import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Stack,
  Icon,
} from "@mui/material";
import LGModal from "../LGModal";
import ConfirmDialog from "./ConfirmDialog";
import {
  deleteClientAddress,
  updateClientAddress,
} from "../../api/client";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import AddressForm from "./AddressForm/index.js";

export default function ClientAddressCard({ address, clientAddressId, onChange }) {
  const [openModal, setOpenModal] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const { openSnack } = useSnack();

  const handleModalClose = () => {
    setOpenModal(false);
    if (onChange) {
      onChange();
    }
  };

  const handleCloseDialog = () => {
    setOpenConfirm(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteClientAddress(clientAddressId);
      openSnack("Dirección eliminada correctamente", "success");
      handleCloseDialog();
      if (onChange) {
        onChange();
      }
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleSubmitAddress = async (addressPayload) => {
    try {
      await updateClientAddress(clientAddressId, addressPayload);
      openSnack("Dirección actualizada exitosamente", "success");
      handleModalClose();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  return (
    <>
      <LGModal
        open={openModal}
        header="Editar Dirección"
        handleClose={handleModalClose}
      >
        <AddressForm
          props={{
            id: 0,
            onSubmit: handleSubmitAddress,
            initialValues: address,
          }}
        />
      </LGModal>

      <ConfirmDialog
        open={openConfirm}
        handleClose={handleCloseDialog}
        handleConfirm={handleConfirmDelete}
      />

      <Card style={{ maxWidth: 400, margin: "auto", flex: 1, height: "100%" }}>
        <CardContent>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" component="div">
              {address.name}
            </Typography>
            <Stack direction="row">
              <IconButton
                size="small"
                color="primary"
                onClick={() => setOpenModal(true)}
              >
                <Icon>edit</Icon>
              </IconButton>
              <IconButton
                size="small"
                color="error"
                onClick={() => setOpenConfirm(true)}
              >
                <Icon>delete</Icon>
              </IconButton>
            </Stack>
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {`${address.street} ${address.outNum}${
              address.innNum ? `, ${address.innNum}` : ""
            }`}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {address.colony}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {address.municipality}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {address.state}, {address.country}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            CP: {address.cp}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}
